import React, { useMemo, useState } from "react";
import CustomToolbar from "./Toolbar";
import { Button } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import ToolbarButton from "./ToolbarButton";
import SavedSimulationsModal from "./SavedSimulationsModal";

interface LayersToolbarProps {
  layers: any;
  direction?: "column" | "row";
  labelSide?: "left" | "right" | "top";
}

const SimulationToolbar: React.FC<LayersToolbarProps> = ({
  layers,
  direction = "column",
  labelSide = "left",
}) => {
  const [savedModalOpen, setSavedModalOpen] = useState(false);

  const toolbarButtons = useMemo(
    () =>
      layers?.flatMap((layer: { toolbarButton: any; controls: any }) =>
        layer.toolbarButton ? [layer.toolbarButton] : layer.controls ?? []
      ),
    [layers]
  );

  const modal = (
    <SavedSimulationsModal
      open={savedModalOpen}
      onClose={() => setSavedModalOpen(false)}
    />
  );

  return (
    <>
      {modal}
      <CustomToolbar direction={direction}>
        <Button
          variant="contained"
          onClick={() => setSavedModalOpen(true)}
          sx={{
            minWidth: 200,
            backgroundColor: "#00d4ad",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#faad17",
            },
          }}
        >
          <ScienceIcon sx={{ mr: 1 }} />
          Simulations
        </Button>
        {toolbarButtons.map((button: React.ReactElement<any>, index: number) =>
          button.type === ToolbarButton
            ? React.cloneElement(button, { key: index, labelSide: labelSide })
            : React.cloneElement(button, { key: index })
        )}
      </CustomToolbar>
    </>
  );
};

export default SimulationToolbar;
